/**
 * Этот Nuxt.js middleware определяет тип устройства пользователя (мобильное или десктопное)
 * на основе `User-Agent` и сохраняет его состояние в глобальном стейте.
 *
 * @param {RouteLocationNormalized} to - Маршрут, на который производится переход.
 * @param {RouteLocationNormalized} from - Маршрут, с которого производится переход.
 */
export default defineNuxtRouteMiddleware((to, from) => {
  // Определяет, выполняется ли код на сервере
  const isServer = import.meta.server;

  // Получает значение User-Agent
  const userAgent = isServer
    ? useRequestHeaders()['user-agent'] || '' // На стороне сервера берется User-Agent из заголовков запроса
    : navigator.userAgent; // На стороне клиента берется User-Agent из объекта navigator

  // Регулярное выражение для определения мобильных устройств
  const isMobile = /iPhone|iPad|Android|Mobile/i.test(userAgent);

  // Глобальное состояние для хранения типа устройства ('mobile' или 'desktop')
  const deviceType = useState('deviceType', (): 'mobile' | 'desktop' => 'desktop'); // Значение по умолчанию: 'desktop'

  // Устанавливаем тип устройства в зависимости от результата проверки
  deviceType.value = isMobile ? 'mobile' : 'desktop';
});
